import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import DayMonthYearInput from '../../components/checkout/DayMonthYear/DayMonthYearInput';

const DayMonthYearInputContainer = props =>
  <Field
    name={props.name}
    component={DayMonthYearInput}
    props={props}
  />
;

DayMonthYearInputContainer.propTypes = {
  name: PropTypes.string
};

export default DayMonthYearInputContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/DayMonthYearInputContainer.js
 **/